import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.r3j_1.f2();
}
function OtpHashAlgorithm$Companion$_anonymous__p1hhmv() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.proof.OtpHashAlgorithm', values());
}
var OtpHashAlgorithm_SHA1_instance;
var OtpHashAlgorithm_SHA256_instance;
var OtpHashAlgorithm_SHA512_instance;
function values() {
  return [OtpHashAlgorithm_SHA1_getInstance(), OtpHashAlgorithm_SHA256_getInstance(), OtpHashAlgorithm_SHA512_getInstance()];
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.r3j_1 = lazy(tmp_0, OtpHashAlgorithm$Companion$_anonymous__p1hhmv);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  OtpHashAlgorithm_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var OtpHashAlgorithm_entriesInitialized;
function OtpHashAlgorithm_initEntries() {
  if (OtpHashAlgorithm_entriesInitialized)
    return Unit_instance;
  OtpHashAlgorithm_entriesInitialized = true;
  OtpHashAlgorithm_SHA1_instance = OtpHashAlgorithm().o4f('SHA1', 0);
  OtpHashAlgorithm_SHA256_instance = OtpHashAlgorithm().o4f('SHA256', 1);
  OtpHashAlgorithm_SHA512_instance = OtpHashAlgorithm().o4f('SHA512', 2);
  Companion_getInstance();
}
var OtpHashAlgorithmClass;
function OtpHashAlgorithm() {
  if (OtpHashAlgorithmClass === VOID) {
    class $ extends Enum() {
      static o4f(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'OtpHashAlgorithm', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    OtpHashAlgorithmClass = $;
  }
  return OtpHashAlgorithmClass;
}
function OtpHashAlgorithm_SHA1_getInstance() {
  OtpHashAlgorithm_initEntries();
  return OtpHashAlgorithm_SHA1_instance;
}
function OtpHashAlgorithm_SHA256_getInstance() {
  OtpHashAlgorithm_initEntries();
  return OtpHashAlgorithm_SHA256_instance;
}
function OtpHashAlgorithm_SHA512_getInstance() {
  OtpHashAlgorithm_initEntries();
  return OtpHashAlgorithm_SHA512_instance;
}
//region block: exports
export {
  OtpHashAlgorithm as OtpHashAlgorithm1ycw1mfra8exn,
  Companion_getInstance as Companion_getInstance2nqzk98fbkur7,
};
//endregion

//# sourceMappingURL=OtpHashAlgorithm.mjs.map
